import {useDispatch, useSelector} from "react-redux";
import {
    SET_IS_EDIT,
    SET_SHOW_FORM
} from "../../../../store/reducers/BoardCreate/constants";
import {CiShare2} from "react-icons/ci";
import {SET_IS_SHOW_SHARE} from "../../../../store/constants";

export const HeaderMenu = ({
                               isMenuOpen,
                               handleOpenActionModal,
                               handleArchiveItems,
                               handleArchiveCards
                           }) => {
    const dispatch = useDispatch();
    const activeBoard = useSelector(state => state.boards.activeBoard);
    const user = useSelector(state => state.user.user);

    const userRole = activeBoard?.rbac?.find(
        (el) => el.user_id === user?.id
    )?.role;
    const handleChangeBoard = () => {
        if(userRole !== 1){
            dispatch({ type: SET_IS_EDIT, payload: true });
            dispatch({ type: SET_SHOW_FORM, payload: true });
        }
    };
    const handleShare = () => {
        if(userRole !== 1){
            dispatch({type: SET_IS_SHOW_SHARE, payload: true})
        }
    }
    return (
        <>
            <div className="boardMenu__share">
                <CiShare2 style={{color: "white", width: 35, height: 35}} onClick={handleShare} />
            </div>
            {isMenuOpen && (
                <div className="boardMenu__dropdown">
                    <button
                        type="button"
                        className="boardMenu__item"
                        onClick={handleChangeBoard}
                    >
                        Change Board
                    </button>

                    <button
                        type="button"
                        className="boardMenu__item"
                        onClick={() =>
                            handleOpenActionModal({
                                targetType: "board",
                                action: "archive",
                            })
                        }
                    >
                        Archive board
                    </button>

                    <button
                        type="button"
                        className="boardMenu__item"
                        onClick={() =>
                            handleOpenActionModal({
                                targetType: "board",
                                action: "delete",
                            })
                        }
                    >
                        Remove board
                    </button>

                    <button
                        type="button"
                        className="boardMenu__item"
                        onClick={handleArchiveItems}
                    >
                        Archived Lists
                    </button>

                    <button
                        type="button"
                        className="boardMenu__item"
                        onClick={handleArchiveCards}
                    >
                        Archived Cards
                    </button>
                </div>
            )}
        </>
    );
};